import React from 'react'
import type { ButtonProps } from '@vtex/admin-ui'
import { IconX, csx, cx } from '@vtex/admin-ui'

export type EditCartItemDrawerCloseButtonProps = ButtonProps

export const EditCartItemDrawerCloseButton = ({
  className = '',
  ...props
}: EditCartItemDrawerCloseButtonProps) => {
  return (
    <button
      data-testid="edit-cart-drawer-close-button"
      aria-label="Close button"
      className={cx(
        csx({
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '100%',
          marginRight: '$space-5',
          marginTop: '$space-7',
          width: '2rem',
          height: '2rem',
          background: '$overlay',
          ':hover': {
            background: '$action.main.primary',
          },
          position: 'absolute',
          color: 'white',
          top: '$space-9',
          right: '$space-7',
        }),
        className
      )}
      {...props}
    >
      <IconX color="white" />
    </button>
  )
}
